<template>
    <div v-show="modalVisibility && !supportedLocales.includes(userLocale)"
         id="locale-modal-container"
    >
        <div class="locale-modal">
            <button class="close"
                    @click="toggleLocaleWarning"
            ></button>
            <div class="modal-content">
                <p>{{ modalContent }}</p>
                <ul>
                    <li v-for="(country, i) in countries"
                        :key="i"
                    >
                        <button @click="forceLocaleRedirect(country[0])"
                                :class="country[0].toLowerCase()"
                        >
                            {{ country[1] }}
                        </button>
                    </li>
                </ul>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'UserLocalization',

    data: () => ({
        supportedLocales: ['CH', 'DE', 'AT'],
        userLocale: '',
        userLang: '',
        modalVisibility: false,
    }),

    props: {
        currentLang: '',
        languagelinks: {},
        countries: {},
        modalContent: '',
        ipcheck: false
    },

    computed: {
    },

    mounted () {
        // If localStorage has no data, get user localization & set localStorage
        if (localStorage.getItem('user-locale')) {
            this.userLocale = localStorage.getItem('user-locale');
            this.userLang = localStorage.getItem('user-lang');
            this.modalVisibility = true;
        } else {
            if (this.ipcheck){
                this.getUserLocalization();
            }
        }

        this.countries.reverse();
    },

    methods: {
        // Fetch data from ipStack
        // https://ipstack.com/documentation
        getUserLocalization() {
            fetch(apiBaseUrl + 'currency/ipstack', {
                        method: 'POST',
                        headers: {
                            'Content-Type': 'application/json',
                            'X-CSRF-Token': yii.getCsrfToken()
                        }
                    })
                .then(response => response.json())
                .then(response => {
                    // Set locale
                    if (response.country_code) {
                        this.userLocale = response.country_code;
                    }
                    //this.userLocale = 'US';

                    // Set lang
                    this.userLang = response.location.languages[0].code;

                    // Set localStorage
                    localStorage.setItem('user-locale', this.userLocale);
                    localStorage.setItem('user-lang', this.userLang);

                    // Redirect to appropriate country & language
                    switch (this.userLocale) {

                        // France
                        case 'FR':
                            this.$emit('updated', {languageLink: this.languagelinks['fr'], country: 'DE'});
                            break;

                        // Dach (CH, DE & AT)
                        case 'DE':
                        case 'CH':
                        case 'AT':
                            this.$emit('updated', {languageLink: this.languagelinks[this.currentlang], country: this.userLocale});
                            break;

                        // All other countries
                        default:
                            this.$emit('updated', {languageLink: this.languagelinks['en'], country: 'DE'});
                    }
                });
        },

        // Toggle warning window, set localStorage & redirect to DE
        toggleLocaleWarning() {
            this.modalVisibility = !this.modalVisibility;
            localStorage.setItem('user-locale', 'DE');
        },

        // Redirect when user clicks on a locale
        forceLocaleRedirect(locale) {
            this.$emit('updated', {languageLink: this.languagelinks[this.currentlang], country: locale});
            localStorage.setItem('user-locale', locale);
        },
    }
}
</script>

<style lang="scss">
    #locale-modal-container {
        top: 0;
        left: 0;
        bottom: 0;
        right: 0;
        width: 100vw;
        height: 100vh;
        position: fixed;
        z-index: 9999;
        background: rgba(0, 0, 0, .4);
        display: flex;
        align-items: center;
        justify-content: center;

        .locale-modal {
            background: white;
            padding: 20px;
            color: black;
            max-width: 80vw;
            border-radius: 3px;
            display: flex;
            flex-direction: column;

            .modal-content {
                display: flex;
                gap: 50px;
                flex-direction: column;
                padding: 40px;
            }

            ul {
                display: flex;
                align-items: center;
                justify-content: space-between;
                flex-wrap: wrap;
                gap: 20px;

                li {
                    flex-shrink: 1;

                    button {
                        padding-left: 50px;
                        background-color: transparent;
                        background-repeat: no-repeat;
                        background-size: 30px;

                        &.at {
                            background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' id='flag-icons-at' viewBox='0 0 640 480'%3E%3Cg fill-rule='evenodd'%3E%3Cpath fill='%23fff' d='M640 480H0V0h640z'/%3E%3Cpath fill='%23c8102e' d='M640 480H0V320h640zm0-319.9H0V.1h640z'/%3E%3C/g%3E%3C/svg%3E");
                        }

                        &.ch {
                            background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' id='flag-icons-ch' viewBox='0 0 640 480'%3E%3Cg fill-rule='evenodd' stroke-width='1pt'%3E%3Cpath fill='red' d='M0 0h640v480H0z'/%3E%3Cg fill='%23fff'%3E%3Cpath d='M170 195h300v90H170z'/%3E%3Cpath d='M275 90h90v300h-90z'/%3E%3C/g%3E%3C/g%3E%3C/svg%3E");
                        }

                        &.de {
                            background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' id='flag-icons-de' viewBox='0 0 640 480'%3E%3Cpath fill='%23ffce00' d='M0 320h640v160H0z'/%3E%3Cpath d='M0 0h640v160H0z'/%3E%3Cpath fill='%23d00' d='M0 160h640v160H0z'/%3E%3C/svg%3E");
                        }
                    }
                }
            }
        }
    }

    button.close {
        align-self: flex-end;
        display: block;
        width: 10px;
        height: 10px;
        background-color: transparent;
	    background-image: url("data:image/svg+xml,%3Csvg width='32' height='32' viewBox='0 0 32 32' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cg clip-path='url(%23clip0_1109_297)'%3E%3Cpath d='M28 4L4 28' stroke='black' stroke-width='8' stroke-linecap='round' stroke-linejoin='round'/%3E%3Cpath d='M4 4L28 28' stroke='black' stroke-width='8' stroke-linecap='round' stroke-linejoin='round'/%3E%3C/g%3E%3Cdefs%3E%3CclipPath id='clip0_1109_297'%3E%3Crect width='32' height='32' fill='white'/%3E%3C/clipPath%3E%3C/defs%3E%3C/svg%3E");
        background-repeat: no-repeat;
        background-size: 100%;
        opacity: .2;
    }

    .invisible {
        visibility: hidden;
    }
</style>